import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue';

import * as Icons from "@ant-design/icons-vue";

const app = createApp(App);

Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key])
})



app.use(store).use(router).use(Antd).mount('#app')
